import React from 'react';
import { TextInput, NumberInput, SelectInput, FormDataConsumer } from 'react-admin';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import DeleteIcon from '@mui/icons-material/Delete';

const cellSx = {
	maxWidth: '85px'
};

const InvoiceLineForm = ({ remove, index, vatList, draggable, variant }) => {
	const handleDelete = () => {
		remove(index);
	};

	return (
		<>
			{draggable && <TableCell><DragHandleIcon /></TableCell>}
			<TableCell><TextInput label="" source={`lines[${index}].description`} multiline variant={variant} helperText={false} /></TableCell>
			<TableCell sx={cellSx}><NumberInput label="" source={`lines[${index}].qty`} variant={variant} helperText={false} /></TableCell>
			<TableCell sx={cellSx}><NumberInput label="" source={`lines[${index}].unit_price`} variant={variant} helperText={false} /></TableCell>
			<TableCell>
				<SelectInput
					label=""
					source={`lines[${index}].vat_code`}
					choices={vatList}
					variant={variant}
					helperText={false}
					sx={{ margin: 0 }}
				/>
			</TableCell>
			<TableCell>
				<FormDataConsumer>
					{({ formData }) => {
						if (formData.lines && formData['lines'][index]) {
							const total = formData['lines'][index].qty * formData['lines'][index].unit_price;

							if (total) {
								return `${total} \u20AC`;
							}
						}

						return null;
					}}
				</FormDataConsumer>
			</TableCell>
			<TableCell align="center">
				<IconButton aria-label="delete" onClick={handleDelete}>
					<DeleteIcon />
				</IconButton>
			</TableCell>
		</>
	);
};

export default InvoiceLineForm;
